<section class="flex flex-col h-full">
  <app-modal-header
    [title]="data.mode === 'upgrade' ? 'Upgrade Your Plan' : 'Change Plan Confirmation'"
    (onClose)="dialogRef.close()" [confirm]="input.toUpperCase() === data.tier.name.toUpperCase()"
    (onConfirm)="confirm()">
  </app-modal-header>

  <mat-dialog-content class="p-6 text-sm">
    <!-- Upgrade View -->
    <div *ngIf="data.mode === 'upgrade'" class="space-y-6">
      <div class="card card-quiet flex items-center space-x-4">
        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center">
          <i class="fas fa-rocket text-2xl text-primary-700"></i>
        </div>
        <div>
          <h3 class="heading-sub">Ready to Upgrade!</h3>
          <p class="text-gray-600 text-sm">You're about to unlock more powerful features</p>
        </div>
      </div>
    </div>


    <!-- Downgrade View -->
    <div *ngIf="data.mode === 'downgrade'" class="space-y-6">
      <div class="flex items-center space-x-4 bg-amber-50 p-3 rounded-control">
        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center">
          <i class="fas fa-exclamation-triangle text-2lg text-amber-700"></i>
        </div>
        <div>
          <h3 class="font-semibold text-amber-900">Please Confirm</h3>
          <p class="text-amber-700 text-sm">You're about to downgrade your plan</p>
        </div>
      </div>
    </div>

    <div class="space-y-4 mt-6">
      <!-- Plan Details -->
      <div class="flex items-center justify-between p-4 bg-gray-50 rounded-control">
        <div class="w-full">
          <p class="text-sm text-gray-500">New Plan</p>
          <p class="w-full text-lg font-bold text-gray-900 flex justify-between">
            {{data.tier.name | uppercase}}
            <span *ngIf="data.yearly">{{yearlyPrice | currency: 'EUR' }}/year</span>
            <span *ngIf="!data.yearly">{{data.tier.price | currency: 'EUR'}}/mo</span>
          </p>
        </div>
      </div>
    </div>

    <!-- Warning for prorration -->
    <div class="mt-6 flex items-start gap-3 p-4 rounded-control bg-gray-50 text-gray-600 text-sm" *ngIf="data.mode === 'downgrade'">
      <i class="fas fa-info-circle mt-0.5 text-gray-400"></i>
      <p>
        Any unused amount from your current plan will be added as credit and automatically applied to future usage or subscription payments.
      </p>
    </div>

    <div class="mt-6 p-4 rounded-control bg-emerald-50/60 border border-emerald-100 text-emerald-800 text-sm" *ngIf="data.mode === 'upgrade'">
      <div class="flex gap-3">
        <i class="fas fa-arrow-up-right-dots mt-0.5"></i>
        <p>
          You are only charged a prorated amount for the current billing period. The full plan price applies from your next renewal.
        </p>
      </div>
    </div>

    <!-- Confirmation Input -->
    <div class="mt-6">
      <div class="text-center mb-4">
        <p class="text-gray-600 mb-2">To confirm, please type:</p>
        <code class="px-4 py-2 bg-gray-100 rounded-control text-gray-700 font-mono">
          {{data.tier.name | uppercase}}
        </code>
      </div>

      <div class="dm-input">
        <label for="">Type to confirm</label>
        <input type="text" [(ngModel)]="input" [placeholder]="data.tier.name | uppercase">
      </div>
    </div>
  </mat-dialog-content>
</section>
